module.exports = __webpack_public_path__ + "static/icon-customerservice-015d16a31a275d6e9ac4b7a0b26b0a22.svg";